import api from "./api";

const banners = `mocks${import.meta.env.VITE_BASE_PATH}banners.lancamentos.json`
var jsonFinal = "" 
class BannerLancamentosService {
  async get() {
    if(!jsonFinal){
      const resp = await fetch(banners)
      jsonFinal = await resp.json()
    }
    return jsonFinal
  }
}

export default new BannerLancamentosService();
